/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const accessibility_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 9.556v4.889m0-4.89 6.5-1.8m-6.5 1.8-6.5-1.8m6.5 6.69L16.776 23M12 14.444 7.224 23m7.14-19.556c0 1.35-1.059 2.445-2.364 2.445S9.636 4.794 9.636 3.444C9.636 2.094 10.695 1 12 1s2.364 1.094 2.364 2.444Z"
    />
  </svg>
)
export default accessibility_medium
